var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_65)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9464 0C8.02249 0 0 8.10776 0 18.1382C0 26.156 5.14029 32.9429 12.2712 35.345C13.1628 35.5256 13.4893 34.9548 13.4893 34.4746C13.4893 34.0541 13.46 32.6127 13.46 31.1109C8.46771 32.1922 7.42812 28.9488 7.42812 28.9488C6.62584 26.8466 5.4371 26.3064 5.4371 26.3064C3.80314 25.1952 5.55612 25.1952 5.55612 25.1952C7.36861 25.3154 8.31967 27.0571 8.31967 27.0571C9.92388 29.8196 12.5089 29.039 13.5489 28.5585C13.6973 27.3873 14.173 26.5765 14.6781 26.1261C10.6964 25.7056 6.50718 24.1442 6.50718 17.177C6.50718 15.195 7.21984 13.5735 8.34906 12.3124C8.1709 11.862 7.54678 9.99981 8.52759 7.50742C8.52759 7.50742 10.0429 7.02685 13.4596 9.36925C14.9224 8.97222 16.431 8.77024 17.9464 8.76854C19.4617 8.76854 21.0064 8.97897 22.4328 9.36925C25.8498 7.02685 27.3651 7.50742 27.3651 7.50742C28.346 9.99981 27.7215 11.862 27.5433 12.3124C28.7023 13.5735 29.3856 15.195 29.3856 17.177C29.3856 24.1442 25.1963 25.6754 21.1849 26.1261C21.8388 26.6966 22.403 27.7775 22.403 29.4894C22.403 31.9217 22.3736 33.8738 22.3736 34.4742C22.3736 34.9548 22.7006 35.5256 23.5918 35.3454C30.7227 32.9426 35.863 26.156 35.863 18.1382C35.8924 8.10776 27.8405 0 17.9464 0Z",
    fill: "url(#paint0_linear_197_65)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_65",
    x1: 2.41615,
    y1: 4.62145,
    x2: 35.8301,
    y2: 12.0059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#861311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 35.3793,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.a1ea6a14a76ee6d43001323f1e712029.svg";
export { ForwardRef as ReactComponent };